import { assign } from 'lodash';
import moment from 'moment'
import { addMessage, addMessageEscaped, addStreamMessage, clearStreamMessages, getSuggestedQuestionsSuccess } from '../chat-body/index';
import * as chatRootActions from '../chat-root/index';
import * as msgs from "../../utils/messages";

export const POST_MESSAGE = 'POST_MESSAGE';
export const POST_SUCCESS = 'POST_SUCCESS';
export const POST_FAILED = 'POST_FAILED';
export const SHOW_WAIT = 'SHOW_WAIT';
export const HIDE_WAIT = 'HIDE_WAIT';
export const SET_TIMEOUT_STREAM = 'SET_TIMEOUT_STREAM';
export const ON_FOCUS_INPUT = 'ON_INPUT_FOCUS';
export const ON_BLUR_INPUT = 'ON_BLUR_FOCUS';
export const UPDATE_HAS_INPUT_VALUE = 'UPDATE_HAS_INPUT_VALUE';
export const UPDATE_LAST_USER_MESSAGE_POSTED_AT_MS = 'UPDATE_LAST_USER_MESSAGE_POSTED_AT_MS';

const TIMEOUT_STREAM = 60 * 1000;

export const postSuccess = () => ({
  type: POST_SUCCESS
});

export const postFailed = () => ({
  type: POST_FAILED
});

export const showWait = () => ({
  type: SHOW_WAIT,
  show: true
});

export const hideWait = () => ({
  type: HIDE_WAIT,
  show: false
});

export const setTimeoutStream = (isTimeout) => ({
  type: SET_TIMEOUT_STREAM,
  value: isTimeout
});

export const onFocusInput = () => ({
  type: ON_FOCUS_INPUT,
  isInputFocused: true
});

export const onBlurInput = () => ({
  type: ON_BLUR_INPUT,
  isInputFocused: false
});

export const updateHasInputValue = (hasValue) => ({
  type: UPDATE_HAS_INPUT_VALUE,
  hasInputValue: hasValue
});

export const updateLastUserMessagePostedAtMs = (postedAtMs) => ({
  type: UPDATE_LAST_USER_MESSAGE_POSTED_AT_MS,
  postedAtMs,
});

export const postMessage = _params => (dispatch, getState) => {
  const { chatRoot } = getState();
  const params = assign({}, _params, {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
  const showWait = !chatRoot.isChatRoomConnected;
  const showWaitMessage = showWait && chatRoot.useWaitMessage;

  if (showWaitMessage) {
    dispatch(chatRootActions.cancelWaitMessageTimer());
    dispatch(chatRootActions.hideWaitMessage());
    dispatch(chatRootActions.startWaitMessageTimer());
  }

  // record the time user posted message
  dispatch(updateLastUserMessagePostedAtMs(Date.now()));

  new Promise(chatRoot.protocol(params))
    .then(function (data) {
      // on chatbot_gateway this then part will never be called,
      // since data will be sent via websocket and passed to
      // cu_webplugin directly through cu.web_plugin.appendMessages
      dispatch(postSuccess());
      dispatch(chatRootActions.cancelWaitMessageTimer());
      dispatch(chatRootActions.hideWaitMessage());
      dispatch(appendMessages(data));
    }, function () {
      dispatch(postFailed());
    });

  if (_params.text !== '***start from bot***') {
    window.hermes.send('cu:sendMessage', {
      tabId: chatRoot.tabId,
      href: window.location.href,
      message: {
        ..._params,
        type: 'text',
        isBot: false,
        withIcon: true,
        time: moment(new Date).format('HH:mm')
      }
    });
  }

  return dispatch({
    type: POST_MESSAGE,
    show: showWait
  });
};

export const appendMessages = (data) => (dispatch, getState) => {
  const { inputField } = getState();
  const messages = msgs.transformMessages(data, {
    userMessagePostedAt: new Date(inputField.lastUserMessagePostedAtMs)
  });

  appendMessageInOrder(messages, dispatch);
};

export const appendMessageInOrder = (data, dispatch) => {
  const d = data.shift();

  // If streaming message, show wail handled in middleware to avoid skipping messages
  if (!d.streaming) {
    dispatch(showWait());
  }

  setTimeout(() => {
    if (d.streaming) {
      handleStreamMessage(d, dispatch);
    } else {
      handleNonStreamMessage(d, dispatch);
    }

    if (data.length !== 0) {
      appendMessageInOrder(data, dispatch);
    }
  }, d.wait_time);
};

export const sendMessage = params => (dispatch) => {
  dispatch(addMessageEscaped(params));
  dispatch(postMessage(params));
};

export const getSuggestedQuestions = (message, qaNodeId) => async (dispatch, getState) => {
  const { chatRoot: { loadSuggestedQuestions } } = getState();
  const result = await loadSuggestedQuestions(message, qaNodeId);
  dispatch(getSuggestedQuestionsSuccess(result.data));
};

const handleStreamMessage = (d, dispatch) => {
  handleTimeoutStream(dispatch)
  dispatch(addStreamMessage(d));
}

let timeoutStreamTimer = null;

const handleTimeoutStream = (dispatch) => {
  dispatch(setTimeoutStream(false))
  if (timeoutStreamTimer) {
    clearTimeout(timeoutStreamTimer);
  }
  timeoutStreamTimer = setTimeout(() => {
    dispatch(setTimeoutStream(true));
    dispatch(hideWait());
    dispatch(clearStreamMessages());
    timeoutStreamTimer = null;
  }, TIMEOUT_STREAM);
}

const handleNonStreamMessage = (d, dispatch) => {
  dispatch(hideWait());
  dispatch(addMessage(d));
}
